<div *ngIf="status">
  <div class="cg-margin-right-sm">
    <ng-leaf-inline-alert
      *ngIf="status === 'APPROVE' || status === 'PARTIAL_APPROVE'"
      status="success"
      [fullWidth]="size === 'default'"
      iconTitle="Success"
    >
      {{ PrecertificationStatus[status] }}
    </ng-leaf-inline-alert>
    <ng-leaf-inline-alert
      *ngIf="status === 'PEND' || status === 'VOID' || status === 'MIXED'"
      status="info"
      [fullWidth]="size === 'default'"
      iconTitle="Pending"
    >
      {{ PrecertificationStatus[status] }}
    </ng-leaf-inline-alert>
    <ng-leaf-inline-alert
      *ngIf="status === 'DENY' || status === 'PARTIAL_DENY'"
      status="error"
      [fullWidth]="size === 'default'"
      iconTitle="Denied"
    >
      {{ PrecertificationStatus[status] }}
    </ng-leaf-inline-alert>
  </div>
</div>
